import slug from "../slug";

function groupCategoriesByParent(categories) {
  const categoryMap = {};
  const rootCategories = [];

  categories.forEach(category => {
    // Skip category ATM
    if(category.title == "ATM") {
      return;
    }

    category.children = [];
    categoryMap[category.id] = category;
  });

  categories.forEach(category => {
    // Skip category ATM
    if(category.title == "ATM") {
      return;
    }
    if (category.parent_id === "" || category.parent_id === null) {
      category.parent_id = null;
    }

    if (category.parent_id === null) {
      rootCategories.push(category);
      //console.log(`Root Category: ${category.name}`);
    } else {
      const parent = categoryMap[category.parent_id];
      if (parent) {
        parent.children.push(category);
        //console.log(`Assigned Category: ${category.name} to Parent: ${parent.name}`);
      } else {
        //console.error(`Parent not found for category ${category.name}`);
      }
    }
  });

  //console.log(rootCategories);
  return createCFTags(rootCategories);
}

const createCFTags = function (rootCategories) {
  const cfTags = [
    {
      'tag': 'cf-robot-message',
      'type': 'text',
      'name': 'welcome',
      'cf-questions': 'Bienvenue au service client de votre Banque !',
    },
    {
      'tag': 'select',
      'type': 'text',
      'name': 'category',
      'cf-questions': 'Choisissez la categorie de la requête ?',
      "children": [
        {
          "tag": "option",
          "cf-label": "Réclamation",
          "value": "category_reclamation",
        },
        {
          "tag": "option",
          "cf-label": "Demandes",
          "value": "category_demandes",
        },
      ]
    }
  ]
  for (const categorie of rootCategories) {
    //console.log(categorie.title)

    if (categorie.children.length !== 0) {
      cfTags.push({
        'tag': 'select',
        'type': 'text',
        'name': 'objet',
        "cf-conditional-category": "category_" + slug(categorie.title),
        'cf-questions': "Choisissez le sujet de la requête ",
        "children": categorie.children.map(ch => ({
          "tag": "option",
          "cf-label": ch.title,
          "value": "objet_" + slug(ch.title),
        }))
      })
      for (const sc of categorie.children) {
        //console.log(1, categorie.title, sc.title)

        if (sc.children.length !== 0) {
          cfTags.push({
            'tag': 'select',
            'type': 'text',
            'name': 'reason',
            "cf-conditional-category": "category_" + slug(categorie.title),
            "cf-conditional-objet": "objet_" + slug(sc.title),
            'cf-questions': "Choisissez le motif de la requête ",
            "children": sc.children.map(ch => ({
              "tag": "option",
              "cf-label": ch.title,
              "value": "reason_" + slug(ch.title),
            }))
          })
          for (const ssc of sc.children) {
            //console.log(2, categorie.title, sc.title, ssc.title)

            if (ssc.children.length !== 0) {
              cfTags.push({
                'tag': 'select',
                'type': 'text',
                'name': 'sub_reason',
                "cf-conditional-category": "category_" + slug(categorie.title),
                "cf-conditional-objet": "objet_" + slug(sc.title),
                "cf-conditional-reason": "reason_" + slug(ssc.title),
                'cf-questions': "Choisissez la raison de la requête ",
                "children": ssc.children.map(ch => ({
                  "tag": "option",
                  "cf-label": ch.title,
                  "value": "sub_reason_" + slug(ch.title),
                }))
              })
              for (const sssc of ssc.children) {
                //console.log(3, categorie.title, sc.title, ssc.title, sssc.title)

                if (sssc.children.length !== 0) {
                  cfTags.push({
                    'tag': 'select',
                    'type': 'text',
                    'name': 'reason_need',
                    "cf-conditional-category": "category_" + slug(categorie.title),
                    "cf-conditional-objet": "objet_" + slug(sc.title),
                    "cf-conditional-reason": "reason_" + slug(ssc.title),
                    "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                    'cf-questions': "Choisissez le besoin de la requête ",
                    "children": sssc.children.map(ch => ({
                      "tag": "option",
                      "cf-label": ch.title,
                      "value": "reason_need_" + slug(ch.title),
                    }))
                  })
                  for (const ssssc of sssc.children) {
                    //console.log(4, categorie.title, sc.title, ssc.title, sssc.title, ssssc.title)

                    if (ssssc.children.length !== 0) {
                      cfTags.push({
                        'tag': 'select',
                        'type': 'text',
                        'name': 'sub_reason_need',
                        "cf-conditional-category": "category_" + slug(categorie.title),
                        "cf-conditional-objet": "objet_" + slug(sc.title),
                        "cf-conditional-reason": "reason_" + slug(ssc.title),
                        "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                        "cf-conditional-reason_need": "reason_need_" + slug(ssssc.title),
                        'cf-questions': "Choisissez le besoin de la requête ",
                        "children": ssssc.children.map(ch => ({
                          "tag": "option",
                          "cf-label": ch.title,
                          "value": "sub_reason_need_" + slug(ch.title),
                        }))
                      })
                      for (const sssssc of ssssc.children) {
                        //console.log(5, categorie.title, sc.title, ssc.title, sssc.title, ssssc.title, sssssc.title)

                        if (sssssc.children.length !== 0) {
                          cfTags.push({
                            'tag': 'select',
                            'type': 'text',
                            'name': 'sub_sub_reason_need',
                            "cf-conditional-category": "category_" + slug(categorie.title),
                            "cf-conditional-objet": "objet_" + slug(sc.title),
                            "cf-conditional-reason": "reason_" + slug(ssc.title),
                            "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                            "cf-conditional-reason_need": "reason_need_" + slug(ssssc.title),
                            'cf-questions': "Choisissez le besoin de la requête ",
                            "children": sssssc.children.map(ch => ({
                              "tag": "option",
                              "cf-label": ch.title,
                              "value": "sub_sub_reason_need_" + slug(ch.title),
                            }))
                          })
                          //   for (const ssssssc of sssssc.children) {
                          //     //console.log(categorie.title,"|", sc.title,"|", ssc.title,"|", sssc.title,"|", ssssc.title,"|", sssssc.title,"6|", ssssssc.title)
                          //     if (ssssssc.children.length!==0){
                          //
                          //     }
                          //   }
                        } else {
                          //console.log("6 end")

                          // cfTags.push({
                          //   'tag': 'input',
                          //   'type': 'email',
                          //   'name': 'email',
                          //   "cf-conditional-reason_need": "reason_need_" + slug(ssssc.title),
                          //   'cf-questions': 'Veuillez saisir votre adresse mail',
                          //   'cf-input-placeholder': 'Entrez votre réponse ici...',
                          //   'cf-error': 'Veuillez vérifier votre e-mail.'
                          // })
                        }
                      }
                    } else {
                      //console.log("5 end")

                      // cfTags.push({
                      //   'tag': 'input',
                      //   'type': 'email',
                      //   'name': 'email',
                      //   "cf-conditional-reason_need": "reason_need_" + slug(ssssc.title),
                      //   'cf-questions': 'Veuillez saisir votre adresse mail',
                      //   'cf-input-placeholder': 'Entrez votre réponse ici...',
                      //   'cf-error': 'Veuillez vérifier votre e-mail.'
                      // })
                    }
                  }
                } else {
                  //console.log("4 end")

                  // cfTags.push({
                  //   'tag': 'input',
                  //   'type': 'email',
                  //   'name': 'email',
                  //   "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                  //   'cf-questions': 'Veuillez saisir votre adresse mail',
                  //   'cf-input-placeholder': 'Entrez votre réponse ici...',
                  //   'cf-error': 'Veuillez vérifier votre e-mail.'
                  // })
                }
              }
            } else {
              //console.log("3 end")

              // cfTags.push({
              //   'tag': 'input',
              //   'type': 'email',
              //   'name': 'email',
              //   "cf-conditional-reason": "reason_" + slug(ssc.title),
              //   'cf-questions': 'Veuillez saisir votre adresse mail',
              //   'cf-input-placeholder': 'Entrez votre réponse ici...',
              //   'cf-error': 'Veuillez vérifier votre e-mail.'
              // })
            }
          }
        } else {
          //console.log("2 end")

          // cfTags.push({
          //   'tag': 'input',
          //   'type': 'email',
          //   'name': 'email',
          //   "cf-conditional-objet": "objet_" + slug(sc.title),
          //   'cf-questions': 'Veuillez saisir votre adresse mail',
          //   'cf-input-placeholder': 'Entrez votre réponse ici...',
          //   'cf-error': 'Veuillez vérifier votre e-mail.'
          // })
        }
      }
    } else {
      //console.log("1 end")
    }
  }

  return cfTags
}

// function slug(text) {
//   return text
//     .toLowerCase() // Convert to lowercase
//     .replace(/[^a-z0-9\s-]/g, '_') // Remove any non-alphanumeric characters (except spaces and hyphens)
//     .replace(/\s+/g, '_') // Replace spaces with hyphens
//     .replace(/-+/g, '_') // Replace multiple hyphens with a single hyphen
//     .replace(/^-+|-+$/g, '_'); // Remove leading/trailing hyphens
// }

export default groupCategoriesByParent;
